export const tableschema7 = {
    "name_table": "Розділ VII. Відомості про використання сучасних інформаційних технологій",
    "titles": [
        "Кількість персональних комп’ютерів, усього, од.",
        "з них",
        "не працюють",
        "термін придбання становить понад 5 років",
        "використовуються в управлінсько-господарській діяльності",
        "підключено до Інтернет",
        "підключено до Wi-Fi",
        "Кількість портативних комп’ютерів, ноутбуків, нетбуків, од.",
        "Кількість планшетів, од.",
        "Кількість інтерактивних комплексів, усього, од.",
        "з них",
        "проєкторів з інтерактивним модулем",
        "інтерактивних дисплеїв",
        "Кількість засобів візуалізації (без інтерактиву), усього, од.",
        "з них",
        "телевізорів",
        "інше",
        "Кількість принтерів, од.",
        "Наявність у закладі системного адміністратора (інженера з обслуговування ПК, локальної мережі тощо) (1 - так; 0 - ні)",
        "Наявність інтернету (1 - так; 0 - ні)",
        "Швидкість фіксованого широкосмугового доступу до інтернету (1 - так; 0 - ні)",
        "від 10 до 30 Мбіт/с",
        "від 30 до 100 Мбіт/с",
        "100 і більше Мбіт/с",
        "Швидкість безпроводового широкосмугового доступу до інтернету (1 - так; 0 - ні)",
        "від 10 до 30 Мбіт/с",
        "від 30 до 100 Мбіт/с",
        "100 і більше Мбіт/с",
        "Потреба у пристроях для навчання, од.",
        "ноутбуки",
        "планшети",
        "Потреба у ліцензійному програмному забезпеченні, од.",
        "пакет програмних засобів офісного призначення"
    ],
    "parts": [
        {
            "title": "Значення",
            "subtitle": "",
            "fields": [
                "PC6100",
                "PC6110",
                "PC6120",
                "PC6130",
                "PC6140",
                "PC6150",
                "PC6160",
                "PC6170",
                "PC6180",
                "PC6200",
                "PC6210",
                "PC6220",
                "PC6230",
                "PC6300",
                "PC6310",
                "PC6320",
                "PC6330",
                "PC6400",
                "PC19",
                "PC20",
                "PC6510",
                "PC6520",
                "PC6530",
                "PC6540",
                "PC6610",
                "PC6620",
                "PC6630",
                "PC6640",
                "PC29",
                "PC30",
                "PC31",
                "PC32",
                "PC33"
            ]
        }
    ],
    "shorts": {
        "titles": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
            "32",
            "33"
        ],
        "parts": [
            "1"
        ]
    }
};